import { useMobile } from 'common-nextjs';
import React from 'react';
import { Button } from 'ui';
import { HeroImage } from '~/components/Homepage/Elements';
import GiftCardLink from '~/components/Links/GiftCardLink';
import {
  FT_GIFT_CARD_PURCHASE_ENABLED,
  FT_GIFT_CARD_PURCHASE_UNAVAILABLE_WARNING,
} from '../../constants/featureToggles';
import DESKTOP_HERO from './images/desktop_hero.jpg';
import MOBILE_HERO from './images/mobile_hero.jpg';

interface Props {
  onRedeemGiftCard: () => void;
}

const GiftCardPageHero: React.FC<Props> = ({ onRedeemGiftCard }) => {
  const mobile = useMobile();

  return (
    <div className="relative mb-4 bg-black py-6 text-center text-white md:mb-8 md:py-24 md:text-left">
      <HeroImage alt="" src={mobile ? MOBILE_HERO : DESKTOP_HERO} />

      <div className="container relative mb-0">
        <h1 className="mb-3 text-4xl font-bold md:mb-4 md:text-6xl">
          SidelineSwap Gift Cards
        </h1>
        <h2 className="mb-8 text-lg font-normal md:text-2xl">
          Give an athlete what they really need.
        </h2>

        <div className="mb-4 flex justify-center space-x-4 md:justify-start">
          {FT_GIFT_CARD_PURCHASE_ENABLED && (
            <GiftCardLink page="purchase">
              <Button color="turf-green">Buy Gift Card</Button>
            </GiftCardLink>
          )}

          <Button color="turf-green" onClick={onRedeemGiftCard}>
            Redeem Gift Card
          </Button>
        </div>

        {FT_GIFT_CARD_PURCHASE_UNAVAILABLE_WARNING && (
          <div className="text-sm">
            * Gift card purchases are currently unavailable
          </div>
        )}

        <div className="text-sm">
          * Gift cards are delivered electronically via email
        </div>
      </div>
    </div>
  );
};

export default GiftCardPageHero;
